import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  CenteredModal,
  SearchDropdown,
  SelectCol,
} from "components/common/modals";
import CountryListDataset from "components/common/CountryListDataset";
// country instrument lists
import INDIA_ETF from "assets/Instruments/INDIA_ETF.json";
import INDIA_STOCK from "assets/Instruments/INDIA_ETF.json";
import US_STOCK from "assets/Instruments/10B_above_US.json";
import US_ETF from "assets/Instruments/US_ETF.json";
import UK_LIST from "assets/Instruments/LSE_ETF.json";
import logo_no_background from "../../assets/icons/fort_logo/logo_white.png";
// import logo_no_background from "../../assets/icons/epislon/epsilon-logo-full-white.png";
// import { LOGO_PATH_NUVAMA_NO_BACKGROUND as logo_no_background } from "utils/constants";
// import logo_no_background from "../../assets/icons/nuvama_logo/nuvama_logo_no_background.png";
import { countries } from "utils/constants";

function AddDCA({ show, setShow, ...props }) {
  // Stock lists
  const INDIA_LIST = [...INDIA_ETF, ...INDIA_STOCK];
  const US_LIST = [...US_STOCK, ...US_ETF];
  // console.log(INDIA_LIST);
  // console.log(US_LIST);

  const [selectedCountry, setSelectedCountry] = useState("United States");
  let selectedOptions = [];
  if (selectedCountry === "India") {
    selectedOptions = INDIA_LIST;
  } else if (selectedCountry === "United States") {
    selectedOptions = US_LIST;
  } else if (selectedCountry === "United Kingdom") {
    selectedOptions = UK_LIST;
  }

  // state for selected stock
  const [selectedStock, setSelectedStock] = useState("");

  const content = (
    <Container>
      <Row>
        {/* header */}
        <Container className="h-100">
          <Col
            sm={12}
            lg={4}
            className="highlighted-card side-card mt-5 mt-lg-0"
          >
            {/* LOGO */}
            <Link
              className="navbar-brand"
              to={"/dashboard"}
              style={{ zIndex: 1 }}
            >
              <img src={logo_no_background} alt="logo" className="logo" />
            </Link>
            <h3 className="mt-4">Smart SIP/DCA</h3>
            <p>
              Dollar Cost Averaging: It is an investment strategy that involves
              investing a fixed amount of money at regular intervals over a
              period of time, regardless of the market conditions.
            </p>
          </Col>
        </Container>

        <Col sm={12} lg={4} className="px-lg-0 mt-4">
          {/* Just a holder for the absolute Col above */}
        </Col>

        {/* Form Inputs */}
        <Col sm={12} lg={8} className="mt-4 mt-lg-5">
          <Row className="">
            <Col sm={12} className="mb-4 text-center text-lg-start">
              <h3>Add your SMART SIP/DCA</h3>
            </Col>
            {/* <Col sm={12} lg={6}>
              <Form.Label for="number input">
                <small>Country</small>
              </Form.Label>
              <Form.Select
                aria-label="select input"
                className="dark-input mt-auto"
                value={selectedCountry}
                onChange={e => setSelectedCountry(e.target.value)}
              >
                <option value="United States">United States</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="India">India</option>
              </Form.Select>
            </Col> */}
            <SelectCol
              label="Country"
              name={"country"}
              value={selectedCountry}
              handleChange={e => setSelectedCountry(e.target.value)}
              options={countries}
            />
            <SearchDropdown
              country={selectedCountry}
              label="Stock"
              name={"ticker"}
              placeholder={"Select Stock"}
              value={selectedStock}
              handleChange={event => {
                setSelectedStock(event.target.value);
              }}
            />
            <Col sm={12} className="mt-4 d-flex justify-content-center">
              <Container>
                <Row
                  style={{
                    padding: "20px",
                    border: "1px solid #4C4B56",
                    borderRadius: "8px",
                  }}
                >
                  <Col sm={12} className="px-0">
                    <h5>Invest amount</h5>
                  </Col>
                  <Col sm={12} lg={6} className="mb-3 px-0 pe-2">
                    <Form.Label for="number input">
                      <small>
                        Percent Down <i className="bi bi-info-circle ps-2"></i>
                      </small>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      aria-label="number input"
                      defaultValue="0"
                      className="mt-auto"
                    />
                  </Col>
                  <Col sm={12} lg={6} className="mb-3 px-0">
                    <Form.Label for="number input">
                      <small>
                        Max Quantity per Order{" "}
                        <i className="bi bi-info-circle ps-2"></i>
                      </small>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      aria-label="number input"
                      defaultValue="1"
                      className="mt-auto"
                    />
                  </Col>
                  <Col sm={12} lg={6} className="mb-3 px-0 pe-2">
                    <Form.Label for="number input">
                      <small>
                        Maximum Quantity{" "}
                        <i className="bi bi-info-circle ps-2"></i>
                      </small>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      aria-label="number input"
                      defaultValue="0"
                      className="mt-auto"
                    />
                  </Col>
                  <Col sm={12} lg={6} className="mb-3 px-0">
                    <Form.Label for="number input">
                      <small>
                        Total Amount <i className="bi bi-info-circle ps-2"></i>
                      </small>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      aria-label="number input"
                      defaultValue="0"
                      className="mt-auto"
                    />
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col sm={12} lg={6} className="mt-3 mt-lg-4">
              <Form.Label for="number input">
                <small>Select Broker</small>
              </Form.Label>
              <Form.Select
                aria-label="select input"
                className="dark-input mt-auto"
              >
                <option value="1">Epsilon</option>
                <option value="2">Zerodha</option>
                <option value="3">Fyers</option>
              </Form.Select>
            </Col>
            <Col sm={12} className="my-3"></Col>
            <Col sm={12} lg={4} xl={3} className="mb-4 order-1 order-lg-2">
              <Button className="w-100 btn-primary">
                <i className="bi bi-plus"></i> Add DCA
              </Button>
            </Col>
            <Col sm={12} lg={4} xl={3} className="order-2 order-lg-1">
              <Button
                onClick={() => setShow(false)}
                className="w-100 btn-primary-outline"
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );

  return (
    <CenteredModal
      bodyContent={content}
      show={show}
      setShow={setShow}
      size="xl"
    />
  );
}

export default AddDCA;
